export const MARKETING_INFO_UPDATE_ERROR = 'MARKETING_INFO_UPDATE_ERROR';
export const PROPERTY_UPDATE_ERROR = 'PROPERTY_UPDATE_ERROR';
export const INTEGRATION_UPDATE_ERROR = 'INTEGRATION_UPDATE_ERROR';

export const N2W_LOCALE_MAP = {
  en: 'EN_US',
  es: 'ES_ES',
};

// Should be only numbers or numbers with dashes in the middle.
export const CDLAC_NUMBER_VALIDATION_REGEX = /^\d+(-\d+)*$/;

// State config key of the Minnesota Housing D Number (one per Minnesota property)
export const MN_HOUSING_D_NUMBER_KEY = 'MNHousingDNumber';

// Address state code of Minnesota properties
export const MINNESOTA_STATE_CODE = 'US-MN';

export const HANDLE_HUD_RECALC_SUCCESS =
  'app/ViewProperty/HANDLE_HUD_RECALC_SUCCESS';
export const HANDLE_HUD_RECALC_FAILURE =
  'app/ViewProperty/HANDLE_HUD_RECALC_FAILURE';

export const MINIMUM_RENT_IN_PROGRESS_TOAST_ID =
  'minimum-rent-update-in-progress';

// Stable id (per property) for the success/error result toast so a second
// notification for the same property replaces the previous toast instead of
// stacking a duplicate.
export const MINIMUM_RENT_RESULT_TOAST_ID = 'minimum-rent-result';

// Fallback timeout (ms) for the async Minimum Rent recalc notification.
// Large properties (e.g. Affinity Gardens, ~280 certs) can take ~103s to
// recalc, so 150s gives enough headroom before the "still processing" toast.
export const MINIMUM_RENT_RECALC_TIMEOUT_MS = 150000;
